import React, { useState, useRef, useEffect } from "react";
import { getPaymentBaseurl, getS3URL } from "../../../../_helpers";
import moment from "moment/moment";
import axiosInstance from "../../../../axios";
import { Loading } from "../../../Other/Loading";
import ChapterDocument from "../../../Courses/CourseDetails/CourseChapterDetails/chapterDocument";
import OverlayContainer from "../../../Overlay/OverlayContainer";

const ForumReplies = ({
  commnetsdata,
  index,
  userId,
  previousPostIndex,
  setDeleteResponse,
  setLoad,
  userQueryActionHandler,
  nestedRepliesCollection,
  fetchUserForumPosts,
  getByIdRepliesCollectionHandlers,
}) => {
  const wrapperRef = useRef(null);
  const { REACT_APP_PAYMENT_API_BASEURL } = process.env;
  const currentUrl = window.location.href;

  const [userForumsInnermostRespondArray, setUserForumsInnermostRespondArray] =
    useState();
  const [dropList, setDropList] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [printCertificate, setPrintCertificate] = useState(false);
  const [cerftificateUrl, setCertificateUrl] = useState();
  const [isForumInnermostRepliesShow, setIsForumInnermostRepliesShow] =
    useState(false);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  const postDeleteHandler = (currentIndex, userCurrentActionStatus) => {
    axiosInstance
      .delete(`${getPaymentBaseurl(currentUrl, true)}/${currentIndex}`)
      .then((res) => {
        setDeleteResponse(res.data.message);
        if (userCurrentActionStatus) {
          setUserForumsInnermostRespondArray((current) =>
            current.filter((items) => items.id !== currentIndex)
          );
        }

        fetchUserForumPosts();
        getByIdRepliesCollectionHandlers(previousPostIndex);
        setLoad(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getByIdRepliesCollectionHandler = (currentIdIndex) => {
    setIsLoading(true);
    axiosInstance
      .get(`${getPaymentBaseurl(currentUrl, true)}/${currentIdIndex}`)
      .then((res) => {
        setUserForumsInnermostRespondArray(res?.data?.data?.replies);
        setIsLoading(false);
        setIsForumInnermostRepliesShow(true);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (
      nestedRepliesCollection !== null &&
      commnetsdata.id === nestedRepliesCollection
    ) {
      getByIdRepliesCollectionHandler(nestedRepliesCollection);
    }
  }, [nestedRepliesCollection]);

  const showHandler = (url) => {
    setCertificateUrl(url);
    setPrintCertificate(!printCertificate);
  };

  return (
    <div className="userComments-Section" key={index}>
      <div>
        <div className="forum-heading-1">
          <div className="forum-heading">
            <div class="user-avatar navbar-profile">
              {commnetsdata?.profileImage && (
                <img
                  alt="profile"
                  src={getS3URL(commnetsdata?.profileImage)}
                ></img>
              )}
            </div>
            <div className=" forum-student">
              <h6>
                {commnetsdata?.firstName} {commnetsdata?.lastName} -
              </h6>
            </div>
            <div className="student-profile">
              <h6>{commnetsdata.title}</h6>
            </div>
          </div>

          <div>
            <p className="time-style">
              {moment(commnetsdata?.time).format("MM/DD/YYYY")}
            </p>
          </div>
          {commnetsdata.userId === userId && (
            <div className="list-edit" onClick={() => setDropList(!dropList)}>
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              {dropList && (
                <div className="edit-delete-drop" ref={wrapperRef}>
                  {!commnetsdata.replies > 0 && (
                    <li
                      className="Edit-btn-post item"
                      onClick={() =>
                        userQueryActionHandler(
                          true,
                          commnetsdata,
                          "levelOne",
                          previousPostIndex
                        )
                      }
                    >
                      Edit
                    </li>
                  )}
                  <li
                    className="Edit-btn-post item"
                    onClick={() => postDeleteHandler(commnetsdata.id)}
                  >
                    Delete
                  </li>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="post-comment">
          <p>{commnetsdata.description}</p>
          <div className="post-forum-images">
            {commnetsdata.files[0].map((file, key) => {
              return (
                <div>
                  {file?.fileName?.includes(".pdf") ? (
                    <span onClick={() => showHandler(getS3URL(file.objectKey))}>
                      {file.fileName}
                    </span>
                  ) : file?.fileName.includes(".mp4") ? (
                    <video src={getS3URL(file.objectKey)} alt="forum-video" />
                  ) : (
                    <img src={getS3URL(file.objectKey)} alt="forum-image" />
                  )}
                </div>
              );
            })}
          </div>
          <p className="media-link-style">
            <a href={commnetsdata.medialink} target="_blank">
              {commnetsdata?.medialink}
            </a>
          </p>
          <div className="comment-ReplyContainer reply-box ForumRepliesContainer">
            {commnetsdata.replies > 0 && (
              <p
                onClick={() =>
                  userForumsInnermostRespondArray?.length > 0
                    ? setIsForumInnermostRepliesShow(
                        !isForumInnermostRepliesShow
                      )
                    : getByIdRepliesCollectionHandler(commnetsdata.id)
                }
              >
                {commnetsdata.replies} Replies
              </p>
            )}

            <button
              onClick={() =>
                userQueryActionHandler(
                  false,
                  commnetsdata,
                  "levelOne",
                  previousPostIndex
                )
              }
            >
              Reply
            </button>
          </div>
        </div>
      </div>
      {isForumInnermostRepliesShow && (
        <div className="sub-commentbox">
          {userForumsInnermostRespondArray &&
            userForumsInnermostRespondArray.length > 0 &&
            userForumsInnermostRespondArray.map(
              (commnetsdataReplies, secindex) => (
                <InnerReplies
                  commnetsdata={commnetsdataReplies}
                  previousPostIndex={commnetsdata.id}
                  userQueryActionHandler={userQueryActionHandler}
                  secindex={secindex}
                  userId={userId}
                  postDeleteHandler={postDeleteHandler}
                />
              )
            )}
        </div>
      )}
      {isLoading && <Loading />}
      {printCertificate && (
        <OverlayContainer>
          <ChapterDocument
            type={"pdf"}
            url={cerftificateUrl}
            closeHandler={showHandler}
            show={printCertificate}
          />
        </OverlayContainer>
      )}
    </div>
  );
};
export default ForumReplies;

export const InnerReplies = ({
  commnetsdata,
  secindex,
  previousPostIndex,
  postDeleteHandler,
  userQueryActionHandler,
  userId,
}) => {
  const wrapperRef = useRef(null);
  const [dropList, setDropList] = useState(false);
  useOutsideAlerter(wrapperRef);
  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropList(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  return (
    <div className="userComments-Section innerReplies-Container" key={secindex}>
      <div>
        <div className="forum-heading-1">
          <div className="forum-heading">
            <div class="user-avatar navbar-profile">
              {commnetsdata?.profileImage && (
                <img
                  alt="profile"
                  src={getS3URL(commnetsdata?.profileImage)}
                ></img>
              )}
            </div>
            <div className="forum-student">
              <h6>
                {commnetsdata?.firstName} {commnetsdata?.lastName} -
              </h6>
            </div>
            <div className="student-profile">
              <h6>{commnetsdata.title}</h6>
            </div>
          </div>

          <div>
            <p className="time-style">
              {moment(commnetsdata?.time).format("MM/DD/YYYY")}
            </p>
          </div>
          {commnetsdata.userId === userId && (
            <div className="list-edit" onClick={() => setDropList(!dropList)}>
              <ul>
                <li></li>
                <li></li>
                <li></li>
              </ul>
              {dropList && (
                <div className="edit-delete-drop" ref={wrapperRef}>
                  <li
                    className="Edit-btn-post"
                    onClick={() =>
                      userQueryActionHandler(
                        true,
                        commnetsdata,
                        "levelTwo",
                        previousPostIndex
                      )
                    }
                  >
                    Edit
                  </li>
                  <li
                    className="Edit-btn-post"
                    onClick={() =>
                      postDeleteHandler(
                        commnetsdata.id,
                        "innermostRepondCollection"
                      )
                    }
                  >
                    Delete
                  </li>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="post-comment">
          <p>{commnetsdata.description}</p>
          <div className="comment-ReplyContainer reply-box"></div>
        </div>
      </div>
    </div>
  );
};
